import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleCard from '../../components/ArticleCard';
import ArticleViewer from '../../components/ArticleViewer';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Troubleshooting Category Page
 */
const Troubleshooting = () => {
  const articles = [
    {
      title: 'Common Issues',
      excerpt: 'Solutions to frequently encountered problems',
      route: getHelpRoute(getHelpArticleRoute('troubleshooting', 'common-issues')),
      readTime: 5
    },
    {
      title: 'Payment Problems',
      excerpt: 'Troubleshoot payment and transaction issues',
      route: getHelpRoute(getHelpArticleRoute('troubleshooting', 'payments')),
      readTime: 4
    },
    {
      title: 'Account Access',
      excerpt: 'Resolve login and account access problems',
      route: getHelpRoute(getHelpArticleRoute('troubleshooting', 'account-access')),
      readTime: 3
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer title="Troubleshooting" showQA={false}>
              <div className="help-category-intro">
                <p>
                  Having trouble? Find solutions to common issues and get back on track quickly.
                </p>
              </div>
              <div className="help-category-articles">
                <h2>Articles</h2>
                <div className="help-articles-grid">
                  {articles.map((article, index) => (
                    <ArticleCard
                      key={index}
                      title={article.title}
                      excerpt={article.excerpt}
                      category="Troubleshooting"
                      route={article.route}
                      readTime={article.readTime}
                    />
                  ))}
                </div>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Troubleshooting;
